import { Controller } from '@hotwired/stimulus';
import { TurboMixin } from '../../mixins/turbo_mixin';

/*
Generic controller for loading comments in panel views.
*/

export default class extends Controller {
  static targets = ['tab'];

  initialize() {
    TurboMixin(this);
  }

  fetchComments(event) {
    this.tabTargets.forEach(tab => tab.classList.remove('active'));
    event.target.classList.add('active');

    this.turboGet(event.target.dataset.url, {});
  }
}
